<template>
	<div class="h-auto space-y-1" ref="editableDiv">
		<div
			v-if="log.date_at"
			ref="dateElement"
			:contenteditable="page.props.auth.user?.role == 'admin' || page.props.auth.user?.id == log.user_id"
			@click="(isEditable = true), updateDate"
			@input="updateDate"
			class="text-center">
			{{ formatDate(log.date_at) }}
		</div>
		<div v-if="isEditable" class="flex justify-start gap-4 mt-2">
			<button @click="saveDate" class="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600">Sauvegarder</button>
			<button @click="isEditable = false" class="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400">Annuler</button>
		</div>
	</div>
</template>

<script setup>
	import { ref, onMounted, onBeforeUnmount } from 'vue';
	import { usePage } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';
	import axios from 'axios';
	import { DateTime } from 'luxon';

	const page = usePage();

	const props = defineProps({
		log: {
			type: Object,
			required: true,
		},
	});

	const isEditable = ref(false);
	const date = ref('');
	const editableDiv = ref(null);

	const formatDate = (dateString) => {
		return DateTime.fromISO(dateString).toLocaleString(DateTime.DATETIME_SHORT);
	};

	const updateDate = (e) => {
		date.value = e.target.innerText;
	};

	const saveDate = () => {
		try {
			if (!date.value) {
				isEditable.value = false;
				return;
			}
			// Parse the user input to a DateTime object
			const parsedDate = DateTime.fromFormat(date.value, 'dd/MM/yyyy HH:mm');

			if (!parsedDate.isValid) {
				toast.error('Format de date invalide. Utilisez le format JJ/MM/AAAA HH:mm');
				return;
			}

			axios
				.post(route('log.updateDate', { log: props.log.id }), { date: date.value, log_id: props.log.id })
				.then((response) => {
					toast.success('Date sauvegardée');
					isEditable.value = false;
				})
				.catch((error) => {
					if (error.response?.data?.error) {
						toast.error(error.response.data.error);
					} else {
						toast.error('La requête a échoué avec le code ' + error.response?.status);
					}
				});
		} catch (error) {
			toast.error('Erreur lors du traitement de la date');
		}
	};

	const clickAway = (event) => {
		if (editableDiv.value && !editableDiv.value.contains(event.target)) {
			isEditable.value = false;
		}
	};

	onMounted(() => {
		document.addEventListener('click', clickAway);
	});

	onBeforeUnmount(() => {
		document.removeEventListener('click', clickAway);
	});
</script>
